document.addEventListener('DOMContentLoaded', function() {
function custom_opt_btn(){
 jQuery('.product-opt-select').on('change', function () {
    var parentDiv = jQuery(this).closest('.product-options-container');
    var variantjson = JSON.parse(jQuery(parentDiv).find('script[type="application/json"]').html());
    var opts = [];
    
    jQuery(parentDiv).find('.product-opt-select').each(function () {
        opts.push(jQuery(this).val());
    });

    var selectedVar = variantjson.filter(function (v) {
        return v.option1 == opts[0] && v.option2 == opts[1] && v.option3 == opts[2];
    });

    var submitButton = jQuery(parentDiv).find('.product-form__cart-submit');
    var addToCartText = submitButton.find('span[data-add-to-cart-text]');
    
    if (selectedVar[0] === undefined || selectedVar[0].available == false) {
        submitButton.attr('disabled', 'true');
        addToCartText.text('Sold out');
    } else {
        submitButton.removeAttr('disabled');
        addToCartText.text('Add to cart');
    }

    jQuery(parentDiv).find('.product-form__variants select').val(selectedVar[0].id).trigger('change');
});

function customAddToCart(event){
    event.preventDefault();

    let form = event.target.closest('form');
    if (!form) return;
    // No Content-Type header; keeps multipart boundary
    UTILS.EcCart.addAndRefresh(new FormData(form))
    .catch((error) => {
        console.error('Error:', error);
    });
}

if (!window.__addToCartCustomClickBound) {
    window.__addToCartCustomClickBound = true;
    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('data-add-to-cart-custom') || event.target.matches('span[data-add-to-cart-text]')) {
            customAddToCart(event);
        }
    });
}


}
custom_opt_btn()
});